module.exports = {
    redirectUri: "https://www.thepuzzlefactory.co/oauth2/redirect",
    apiBaseUrl: "https://www.thepuzzlefactory.co/tpf",
    baseUrl: "https://www.thepuzzlefactory.co/tpf"
  };